import type { GetAdminFirms } from '@cloudFunctions/types/admin/getAdminFirms';
import type { BackendPathParams, BackendRouteDefinition } from '../types';

export const getAdminFirmsRoute = {
  transport: 'api',
  method: 'GET',
  path: '/admin/firms/:firmId?',
  params: (requestData?: GetAdminFirms.Props): BackendPathParams =>
    requestData?.firmId ? { firmId: requestData.firmId } : {},
  query: (requestData?: GetAdminFirms.Props) => ({
    finixEnvironment: requestData?.finixEnvironment,
  }),
} as const satisfies BackendRouteDefinition;
